import React from "react";
import { Box, Typography, Chip, Grid, Button, IconButton, Paper } from "@mui/material";
import { useSelector } from "react-redux";
import SelectableRadioGroupManager from "../../../selectable-radio-group-manger";
import MicIcon from "@mui/icons-material/Mic";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";

const emotions = [
  "Calm",
  "Scared",
  "Anxious",
  "Angry",
  "Upset",
  "Tense",
  "Withdrawn",
  "Relieved",
  "Defeated",
  "Disconnected",
  "Other",
];
const anythings = [
  "Apologetic",
  "Silent",
  "Defiant",
  "Cooperative",
  "Confused",
  "Grateful",
  "Hostile",
  "Dismissive",
  "Curious",
  "Indifferent",
  "Other",
];
const requests = [
  "Comfort",
  "Space",
  "Water",
  "Privacy",
  "Reassurance",
  "Apology",
  "Explanation",
  "Leave",
  "Support",
  "Food",
  "Other",
];

const behaviors = [
  "Crying",
  "Sitting",
  "Pacing",
  "Fidgeting",
  "Isolating",
  "Cooperating",
  "Aggressive",
  "Self-soothing",
  "Walking",
  "Staring",
  "Other",
];

const responses = [
  "Reassured",
  "Monitored",
  "Debriefed",
  "Comforted",
  "Observed",
  "Supported",
  "Redirected",
  "Listened",
  "Calmed",
  "Guided",
  "Other",
];

const PhysicalInterventionManager = ({ nextStep, prevStep, physicalData }) => {
  const user = useSelector((state) => state.auth.user); // User data from Redux store

  const allowedBehaviors = physicalData?.map((b) => b.behavior);
  return (
    <Box sx={{ pl: 4, pr: 4, ml: 2 }}>
      <Chip
        variant='contained'
        sx={{
          fontSize: "14px",
          backgroundColor: "#F2F6FF",
          color: "blue",
        }}
        label='Daily Log'
        size='small'
      />
      <Typography sx={{ fontSize: "24px", color: "black", fontWeight: "bold" }}>Incident Management</Typography>
      <Typography variant='subtitle2' sx={{ color: "#757575" }}>
        Date: {new Date().toLocaleDateString()} &nbsp; • &nbsp;{" "}
        <span style={{ color: "#1751D0" }}>{user.username}</span>
      </Typography>
      <Box sx={{ borderBottom: "1px solid #E0E0E0", mt: 2, mb: 2 }} />

      <Grid container spacing={2}>
        <Grid item lg={8} md={8}>
          <Typography sx={{ fontSize: "16px", fontWeight: "bold", color: "black" }}>Emotions</Typography>
          <Typography sx={{ fontSize: "14px", mb: 2 }}>
            How was the young person post physical intervention of emotions
          </Typography>
          <SelectableRadioGroupManager options={emotions} allowedOptions={allowedBehaviors} />

          <Typography sx={{ fontSize: "16px", fontWeight: "bold", color: "black", mt: 3 }}>Anything Said</Typography>
          <Typography sx={{ fontSize: "14px", mb: 2 }}>
            How was the young person post physical intervention of anything said
          </Typography>

          <SelectableRadioGroupManager options={anythings} allowedOptions={allowedBehaviors} />

          <Typography sx={{ fontSize: "16px", fontWeight: "bold", color: "black", mt: 3 }}>Any Requests</Typography>
          <Typography sx={{ fontSize: "14px", mb: 2 }}>
            How was the young person post physical intervention of any requests
          </Typography>

          <SelectableRadioGroupManager options={requests} allowedOptions={allowedBehaviors} />

          <Typography sx={{ fontSize: "16px", fontWeight: "bold", color: "black", mt: 3 }}>
            What were they doing ?
          </Typography>
          <Typography sx={{ fontSize: "14px", mb: 2 }}>How was the young person post physical intervention</Typography>

          <SelectableRadioGroupManager options={behaviors} allowedOptions={allowedBehaviors} />

          <Typography sx={{ fontSize: "16px", fontWeight: "bold", color: "black", mt: 3 }}>
            What actions staff took ?
          </Typography>
          <Typography sx={{ fontSize: "14px", mb: 2 }}>
            How was the young person post physical intervention of any actions staff took
          </Typography>

          <SelectableRadioGroupManager options={responses} allowedOptions={allowedBehaviors} />
        </Grid>
        <Grid item lg={4} md={4}>
          {/* Incident Management Details Section - Recorded Entries */}
          <Box sx={{ mt: 4 }}>
            <Typography sx={{ fontSize: "14px", color: "black", fontWeight: "bold", mb: 2 }}>
              Incident Management
            </Typography>

            {physicalData.length > 0 ? (
              <>
                {[
                  { title: "Emotions", data: emotions },
                  { title: "Anything Said", data: anythings },
                  { title: "Any Requests", data: requests },
                  { title: "What were they doing", data: behaviors },
                  { title: "What actions staff took", data: responses },
                ].map((category, index) => (
                  <Box key={index} sx={{ mt: 2 }}>
                    <Typography sx={{ fontSize: "14px", fontWeight: "bold", mb: 1, color: "black" }}>
                      {category.title}
                    </Typography>
                    {physicalData
                      .filter((record) => category.data.includes(record.behavior))
                      .map((record, recordIndex) => (
                        <Paper
                          key={recordIndex}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            padding: 1,
                            mb: 1,
                            borderRadius: 2,
                            border: "1px solid #ccc",
                          }}
                        >
                          <Typography sx={{ fontSize: "14px", color: "black" }}>
                            {record.audio ? (
                              record.behavior
                            ) : (
                              <>
                                {record.behavior}
                                <br />
                                {record.note}
                              </>
                            )}
                          </Typography>

                          <Box>
                            {record.audio && (
                              <>
                                <IconButton onClick={() => window.open(record.audio, "_blank")}>
                                  <MicIcon color='primary' />
                                </IconButton>
                                <IconButton onClick={() => window.open(record.audio, "_blank")}>
                                  <CloudDownloadIcon color='primary' />
                                </IconButton>
                              </>
                            )}
                          </Box>
                        </Paper>
                      ))}
                  </Box>
                ))}
              </>
            ) : (
              <Typography sx={{ fontSize: "14px", color: "gray" }}>No incident records found.</Typography>
            )}
          </Box>
        </Grid>
      </Grid>

      {/* Footer Actions */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          gap: 2,
          position: "sticky",
          bottom: 0,
          background: "#fff",
          padding: 2,
          zIndex: 10,
        }}
      >
        <Button
          variant='outlined'
          color='primary'
          onClick={() => {
            window.scrollTo(0, 0); // Prevent scrolling
            prevStep();
          }}
        >
          Previous
        </Button>

        <Button
          variant='contained'
          color='primary'
          onClick={() => {
            window.scrollTo(0, 0); // Prevent scrolling
            nextStep(); // Call the function properly
          }}
        >
          Next
        </Button>
      </Box>
    </Box>
  );
};

export default PhysicalInterventionManager;
